import React from "react";
import { StandardModal } from "./StandardModal";
import cancelIcon from "../../assets/noun-cancel-8188481.svg";

export interface ConfirmModalProps {
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** "danger" renders a red confirm button; "primary" uses the default brand color */
  variant?: "danger" | "primary";
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmModal({
  title,
  description,
  confirmLabel = "Bevestigen",
  cancelLabel = "Annuleren",
  variant = "primary",
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  return (
    <StandardModal
      title={title}
      onClose={onCancel}
      maxWidth="440px"
      actions={{
        secondary: {
          label: cancelLabel,
          onClick: onCancel,
          icon: (
            <img src={cancelIcon} alt="" width={16} height={16} aria-hidden />
          ),
        },
        ...(variant === "danger"
          ? {
              danger: {
                label: loading ? "..." : confirmLabel,
                onClick: onConfirm,
                disabled: loading,
                loading,
              },
            }
          : {
              primary: {
                label: loading ? "..." : confirmLabel,
                onClick: onConfirm,
                disabled: loading,
                loading,
              },
            }),
      }}
    >
      {description && (
        <p style={{ marginTop: 0, marginBottom: 0 }}>{description}</p>
      )}
    </StandardModal>
  );
}
